import { RealEstateApi, Configuration as RealEstateConfig } from 'api/real-estate';
import { createApiConfig } from './adapters';

export const realEstateAPI = new RealEstateApi(createApiConfig(RealEstateConfig));
